import React from 'react'
import { Chip, TextField } from '@mui/material'
import useStyles from '../../styles'

interface FavoritesFilterProps {
  favoriteType: string
  searchValue: string
  setSearchValue: (value: string) => void
  handleFavoriteTypeChange: (type: string) => void
}

const FavoritesFilter: React.FC<FavoritesFilterProps> = ({
  favoriteType,
  searchValue,
  setSearchValue,
  handleFavoriteTypeChange
}) => {
  const classes = useStyles()
  return (
    <div className={classes.chipRoot}>
      <TextField
        value={searchValue}
        onChange={e => setSearchValue(e.target.value)}
        placeholder='Search'
        size='small'
        variant='outlined'
        style={{ backgroundColor: 'white' }}
        InputProps={{
          classes: {
            input: classes.searchInput
          }
        }}
      />
      <Chip
        label='All'
        color={favoriteType === 'All' ? 'primary' : 'secondary'}
        onClick={() => {
          handleFavoriteTypeChange('All')
        }}
      />
      <Chip
        label='Conversations'
        color={favoriteType === 'Conversations' ? 'primary' : 'secondary'}
        onClick={() => {
          handleFavoriteTypeChange('Conversations')
        }}
      />
      <Chip
        label='Team chats'
        color={favoriteType === 'Team chats' ? 'primary' : 'secondary'}
        onClick={() => {
          handleFavoriteTypeChange('Team chats')
        }}
      />
      <Chip
        label='Tasks'
        color={favoriteType === 'Tasks' ? 'primary' : 'secondary'}
        onClick={() => {
          handleFavoriteTypeChange('Tasks')
        }}
      />
      <Chip
        label='Contacts'
        color={favoriteType === 'Contacts' ? 'primary' : 'secondary'}
        onClick={() => {
          handleFavoriteTypeChange('Contacts')
        }}
      />
      <Chip
        label='Team'
        color={favoriteType === 'Team' ? 'primary' : 'secondary'}
        onClick={() => {
          handleFavoriteTypeChange('Team')
        }}
      />
      <Chip
        label='Articles'
        color={favoriteType === 'Articles' ? 'primary' : 'secondary'}
        onClick={() => {
          handleFavoriteTypeChange('Articles')
        }}
      />
    </div>
  )
}
export default FavoritesFilter
